import { inject } from '@angular/core';
import { CanActivateChildFn } from '@angular/router';
import { MAX_TABS, NavigationTabsService } from '../services/core/utils/navigation-tabs.service';
import { UtilidadesService } from '../services/core/utils/utilidades.service';
import { baseIdDesdeSnapshot } from '../services/core/utils/navigation-tab-id.util';

export const tabLimitGuard: CanActivateChildFn = (_route, state) => {
  const tabsService = inject(NavigationTabsService);
  const utilidades = inject(UtilidadesService);

  // state.url es la URL completa de destino y state.root el árbol futuro, así que
  // el id calculado aquí es el mismo que usará después NavigationTabsService.sync().
  if (tabsService.puedeAbrir(state.url, baseIdDesdeSnapshot(state.root))) {
    return true;
  }

  utilidades.mostrarAlerta(
    'warning',
    'Advertencia',
    `Sólo puedes tener ${MAX_TABS} pestañas abiertas. Cierra una para poder abrir otra.`,
  );

  return false;
};
